import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

export type DemoRequest = {
  name: string;
  email: string;
  message: string;
  slots: string[];
  clientRequestId?: string;
};
export type MarketingRuntime = {
  signup?: ReactNode;
  checkout?: (seats: number) => Promise<void>;
  subscribe?: (email: string) => Promise<void>;
  requestDemo?: (request: DemoRequest) => Promise<void>;
};
export const MarketingRuntimeContext = createContext<MarketingRuntime>({});
export const useMarketingRuntime = () => useContext(MarketingRuntimeContext);
